(() => {
  const SOCIAL_PROOF_SELECTORS = [
    '.spr-badge',
    '.spr-container',
    '.spr-review',
    '.loox-rating',
    '.loox-reviews-default',
    '.product-reviews',
    '[data-product-reviews]',
  ];

  const JUDGEME_SELECTOR = '.jdgm-widget, .jdgm-preview-badge, #judgeme_product_reviews';
  const SOCIAL_PROOF_PATTERN =
    /\b(?:from\s+)?\d[\d,]*(?:\.\d+)?\s+(?:reviews?|ratings?|orders?|sales?|sold)\b/i;

  const collect = (root, selector) => {
    const matches = [];
    if (root instanceof Element && root.matches(selector)) matches.push(root);
    if (root?.querySelectorAll) matches.push(...root.querySelectorAll(selector));
    return matches;
  };

  const normalizeSalePrice = (saleContainer) => {
    if (!(saleContainer instanceof Element) || !saleContainer.isConnected) return;

    const priceRoot = saleContainer.closest('.price');
    const currentPrice = saleContainer.querySelector('.price-item--sale');
    const regularContainer = priceRoot?.querySelector('.price__regular');

    if (!priceRoot || !currentPrice || !regularContainer) return;

    currentPrice.classList.remove('price-item--sale');
    currentPrice.classList.add('price-item--regular');
    regularContainer.replaceChildren(currentPrice);
    saleContainer.remove();

    priceRoot.classList.remove('price--on-sale');
    priceRoot.querySelectorAll('.price__badge-sale').forEach((badge) => badge.remove());
  };

  const cleanRoot = (root = document) => {
    if (!root?.querySelectorAll && !(root instanceof Element)) return;
    if (root instanceof Element && root.closest(JUDGEME_SELECTOR)) return;

    collect(
      root,
      '.product__info-container s.price-item, .card-wrapper s.price-item, .predictive-search s.price-item'
    ).forEach((element) => element.remove());

    collect(
      root,
      '.card-wrapper .price__sale, .product__info-container .price__sale, .predictive-search .price__sale'
    ).forEach(normalizeSalePrice);

    collect(root, '.badge.price__badge-sale, .badge.price__badge-sold-out')
      .forEach((element) => element.remove());

    collect(root, SOCIAL_PROOF_SELECTORS.join(','))
      .filter((element) => !element.closest(JUDGEME_SELECTOR))
      .forEach((element) => element.remove());

    collect(root, 'p, span, div').forEach((element) => {
      if (element.closest(JUDGEME_SELECTOR)) return;
      if (element.children.length > 0) return;
      const text = element.textContent?.trim();
      if (!text || text.length > 90) return;
      if (SOCIAL_PROOF_PATTERN.test(text)) element.remove();
    });
  };

  const init = () => {
    cleanRoot(document);

    const pendingRoots = new Set();
    let frameId = 0;

    const flush = () => {
      frameId = 0;
      const roots = [...pendingRoots];
      pendingRoots.clear();
      roots.forEach((root) => {
        if (root.isConnected) cleanRoot(root);
      });
    };

    const queueRoot = (root) => {
      if (!(root instanceof Element) || root.closest(JUDGEME_SELECTOR)) return;
      pendingRoots.add(root);
      if (!frameId) frameId = window.requestAnimationFrame(flush);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => queueRoot(node));
      });
    });

    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
